import { Badge, cn } from "@tellescope/ui";
import { ManagedContentPreview } from "./ManagedContentPreview";
import type { AttachFileDialogContentModel } from "./types";

export interface ManagedContentRowProps {
  record: AttachFileDialogContentModel;
  selected: boolean;
  onToggle: (id: string) => void;
}

export const ManagedContentRow = ({ record, selected, onToggle }: ManagedContentRowProps) => (
  <button
    className={cn(
      "flex items-center gap-3 py-3 px-4 hover:bg-gray-50 cursor-pointer w-full justify-start text-left border rounded-md transition-all mb-2",
      selected && "border border-primary bg-gray-100"
    )}
    onClick={() => onToggle(record.id)}
  >
    <div className="flex items-center gap-2 flex-1 min-w-0 justify-between">
      <div className="flex-1 min-w-0">
        <span className="flex items-center gap-2">
          <p className="text-sm truncate">{record.title}</p>
          {record.type && <Badge variant="secondary">{record.type}</Badge>}
        </span>
        {record.description && <p className="text-xs text-muted-foreground truncate">{record.description}</p>}
        {!!record.tags?.length && (
          <span className="flex gap-2 items-center mt-2">
            {record.tags.map((tag) => (
              <Badge key={`${tag}-${record.id}`} variant="secondary">
                {tag}
              </Badge>
            ))}
          </span>
        )}
      </div>
      <ManagedContentPreview type={record.type} headerPhoto={record.headerPhoto} title={record.title} />
    </div>
  </button>
);
